import { useContext, useMemo } from 'react';
import { Address } from 'viem';

import {
  DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS,
  LIQUID_STAKING_TOKEN_ADDRESS,
} from 'modules/api/const';
import { LiquidStakingPoolContext } from 'modules/liquidStaking/LiquidStakingPoolContext';

interface IUseLiquidStakingPool {
  poolAddress: Address;
  isDeprecated: boolean;
}

export function useLiquidStakingPool(): IUseLiquidStakingPool {
  const poolAddress =
    useContext(LiquidStakingPoolContext) ?? LIQUID_STAKING_TOKEN_ADDRESS;

  const isDeprecated = useMemo(() => {
    return (
      !!poolAddress &&
      poolAddress.toLowerCase() ===
        DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS.toLowerCase()
    );
  }, [poolAddress]);

  return {
    poolAddress,
    isDeprecated,
  };
}
